const ContentTypesLowercaseEnum = {
  offer: 'offer',
  checkpoint: 'checkpoint',
  liveTraining: 'liveTraining',
  curriculumOffer: 'curriculumOffer'
};

export { ContentTypesLowercaseEnum };
export default ContentTypesLowercaseEnum;
